import { Result } from '../Result/index.js';
export const delay = (ms) => new Promise((res) => {
    setTimeout(() => {
        res(undefined);
    }, ms);
});
export const deferred = () => {
    let complete;
    let isResolved = false;
    const promise = new Promise((res) => {
        complete = (value) => {
            if (isResolved) {
                return !isResolved;
            }
            isResolved = true;
            res(value);
            return !isResolved;
        };
    });
    return {
        promise,
        complete,
        succeed: (ok) => complete(Result.succeed(ok)),
        fail: (error) => complete(Result.fail(error)),
    };
};
//# sourceMappingURL=Async.js.map